<template>
  <div>
    <client-informations />
    <changing-password />
    <newsletter-subscription />
    <remove-profile />
  </div>
</template>

<script>
import RemoveProfile from './RemoveProfile.vue'
import ChangingPassword from './ChangingPassword.vue'
import NewsletterSubscription from './NewsletterSubscription.vue'
import ClientInformations from './ClientInformations.vue'
export default {
  name: 'MyProfile',
  components: {
    ClientInformations,
    ChangingPassword,
    NewsletterSubscription,
    RemoveProfile,
  },
  data: function() {
    return {
      count: 0,
    }
  },
  mounted() {
    window.scrollTo(0,0)
  },
}
</script>

<style></style>
